import type { Source } from '@casetrace/shared';
import { Loader2 } from 'lucide-react';

export function ImportStatusIndicator({ source }: { source: Source }) {
  if (source.type === 'iphone_backup') return null;

  if (source.status === 'importing') {
    return (
      <span className="flex items-center gap-1 px-2 py-1 text-xs text-[#5e6070]">
        <Loader2 size={12} className="animate-spin" />
        Importerer…
      </span>
    );
  }

  if (source.status === 'pending') {
    return (
      <span className="flex items-center gap-1 px-2 py-1 text-xs text-[#5e6070]">
        <Loader2 size={12} className="animate-spin" />
        Starter…
      </span>
    );
  }

  return null;
}
